import { useSyncExternalStore } from "react";
import { APP_CONSTANTS } from "@/config";

const selectedTenant = () => localStorage.getItem(APP_CONSTANTS.COMPANY_LOCAL_STORAGE_KEY);
const subscribe = (listener: () => void) => {
  window.addEventListener("storage", listener);
  return () => window.removeEventListener("storage", listener);
};

/**
 * The clinic this session acts for. `/me` (UserResource) omits `tenant_id`, so
 * the selected tenant — the X-Tenant scope every request carries — fills in,
 * as `useClinicModules` already does.
 */
export function useTenantId(user: { tenant_id?: string | null } | null | undefined): string | null {
  const selected = useSyncExternalStore(subscribe, selectedTenant, () => null);
  return user?.tenant_id || selected;
}
